import React, { useEffect, useState } from "react";
import { Card, Radio, Button, Alert, Skeleton, Space } from "antd";
import { fetchApi } from "../services/api";

export default function QuestionOfTheDay() {
  const [qod, setQod] = useState(null);
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadQOD() {
      const res = await fetchApi("qodwp");

      const data = res?.data?.questions?.[0] || null;
      setQod(data);
        setLoading(false);
        setLoading(false);
      setLoading(false);
    }

    loadQOD();
  }, []);

  const submitAnswer = () => {
    if (!selected || !qod) return;
    const correct = Number(qod.correct_option?.[0]);
    setStatus(selected === correct ? "correct" : "incorrect");
  };

  if (loading || !qod) {
    return (
      <div className="bg-[#f3f3f3] min-h-screen py-14 px-4 flex justify-center">
        <Card className="w-full max-w-4xl">
          <Skeleton active paragraph={{ rows: 2 }} title={{ width: "60%" }} />
          <div className="mt-6 space-y-4">
            <Skeleton.Button active block />
            <Skeleton.Button active block />
            <Skeleton.Button active block />
            <Skeleton.Button active block />
          </div>
          <div className="mt-6">
            <Skeleton.Button active size="large" block />
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div className="py-9 px-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-center text-3xl font-bold text-[#333] tracking-wide">
          Question of the Day
        </h1>

        <Card className="mt-8 shadow-lg border border-gray-200">
          <div
            className="text-lg font-semibold text-gray-800 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: qod.question_text }}
          />

          <Radio.Group
            onChange={(e) => setSelected(e.target.value)}
            value={selected}
            className="mt-6 w-full space-y-4"
            style={{ width: "100%" }}
            disabled={!!status} // disable after submit
          >
            {[qod.option_first, qod.option_second, qod.option_third, qod.option_fourth].map(
              (opt, idx) => {
                if (!opt) return null;

                const optionValue = idx + 1;
                const correct = Number(qod.correct_option?.[0]);

                // Highlight logic
                let highlightClass = "border-gray-300";
                if (status) {
                  if (optionValue === correct) {
                    highlightClass = "border-green-600 bg-green-50";
                  } else if (optionValue === selected) {
                    highlightClass = "border-red-600 bg-red-50";
                  }
                }

                return (
                  <Card
                    key={idx}
                    size="small"
                    className={`cursor-pointer mb-3 transition border ${highlightClass}`}
                  >
                    <Radio
                      value={optionValue}
                      className="w-full flex items-start gap-3"
                    >
                      <Space>
                        <span className="font-bold text-[#00AAB5]">
                          {String.fromCharCode(65 + idx)}.
                        </span>
                        <span dangerouslySetInnerHTML={{ __html: opt }} />
                      </Space>
                    </Radio>
                  </Card>
                );
              }
            )}
          </Radio.Group>

          <div className="mt-7 text-center">
            <Button
              type="primary"
              size="large"
              className="bg-[#00AAB5] font-semibold px-10"
              onClick={submitAnswer}
              disabled={!!status}
            >
              Submit
            </Button>
          </div>

          {status && (
            <div className="mt-6">
              <Alert
                message={status === "correct" ? "Correct Answer!" : "Incorrect Answer!"}
                type={status === "correct" ? "success" : "error"}
                showIcon
              />
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
